import React, { Component } from "react";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import {
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";

import { MenuItem, Select } from "@material-ui/core";

import Form from "react-bootstrap/Form";

// import Unblock from "../../../assets/images/Unblock.svg";
import delivaApiService from "../../../common/services/apiService";
import {
  getLocalStorage,
  clearLocalStorage,
  showErrorToast,
} from "../../../common/helpers/Utils";
import Loader from "../../common/Loader";
import tooltip from "../../../assets/images/Info.png";
import CaretDown from "../../../assets/images/CaretDown.svg";
import reject from "../../../assets/images/reject.svg";
import { connect } from "react-redux";
import { actionFetchCountries } from "../../../common/redux/actions/actionCountry";
import {
  normalizeCountryOptions,
  sortedCountries,
} from "./settingsCountryUtils";
import { toTitleCase } from "../../../common/helpers/Utils";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteVendors: false,
      allCustomers: [],
      pageno: 1,
      records: 10,
      sort: "",
      keyword: "",
      search: "",
      totalOrders: [],
      delivaCommission: null,
      paymentCycle: null,
      paCommission: null,
      protectYourPackage: null,
      radiusUnit: "km",
      unit: "km",
      deliveryRequestPickupRadius: null,
      distanceNearby: "",
      distanceShort: "",
      distanceLong: "",
      isTwilioOn: false,
      isTermiiOn: false,
      smsProvider: "TERMI",
      twilioOnTimeInHours: 0,
      twilioMessage: null,
      documentationType: "",
      MANUAL_DOCUMENTATION: "",
      DOJAH_DOCUMENTATION: "",
      isFavouritedEnable: false,
      routeSubscriptionLimit: "",
      routeCreateLimit: "",
      routeCreateInMonth: 1,
      country: [],
      countryOptions: [],
      staticCountryOptions: [],
      providerCountryOptions: [],
      providerCountryOptionsLoading: false,
      providerCountryOptionsByCategory: {
        SMS: [],
        KYC: [],
        PAYMENT: [],
      },
      providerCountryOptionsLoadingByCategory: {
        SMS: false,
        KYC: false,
        PAYMENT: false,
      },
      dropdownOpen: false,
      countrySearch: "",
      tempSelectedCountries: [],
      showRemoveModal: false,
      countryToRemove: null,
      distanceUnits: [],
      // Payment provider state
      paymentProvider: "PAYSTACK",
      paymentCountrySearch: "",
      paymentDropdownOpen: false,
      paymentTempSelected: [],
      paymentCountries: {
        STRIPE: [],
        FLUTTERWAVE: [],
        PAYSTACK: [],
      },
      smsCountrySearch: "",
      smsDropdownOpen: false,
      smsTempSelected: [],
      smsCountries: {
        TERMI: [],
        DOJAH: [],
        TWILIO: [],
      },
      kycProvider: "DOJAH",
      kycCountrySearch: "",
      kycDropdownOpen: false,
      kycTempSelected: [],
      kycCountries: {
        DOJAH: [],
        SUMSUB: [],
        MANUAL: [],
      },
      providerCountries: [],
    };
  }
  handleRadioChange = (provider) => {
    this.setState((prev) => ({
      smsProvider: provider,
      smsTempSelected: [...prev.smsCountries[provider]],
      smsDropdownOpen: false,
      smsCountrySearch: "",
    }));
    this.setState({
      isTwilioOn: provider === "TWILIO",
      isTermiiOn: provider === "TERMI",
    });
  };

  deriveCountryState(countries) {
    const sorted = [...(countries || [])].sort((a, b) =>
      a.countryName.localeCompare(b.countryName),
    );
    const countryOptions = sorted.map((item) => ({
      label: item.countryName,
      value: item.countryName,
      countryId: item.countryId || item.id || item.country_id || item.countryID,
    }));
    const distanceUnits = [
      ...new Set(sorted.map((c) => c.distanceUnit).filter(Boolean)),
    ];
    this.setState({ countryOptions, distanceUnits });
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    if (getLocalStorage("adminInfo")) {
      this.getsetting();
      this.fetchProviderCountryOptions("SMS");
      this.fetchProviderCountryOptions("KYC");
      this.fetchProviderCountryOptions("PAYMENT");
      if (this.props.countries && this.props.countries.length > 0) {
        // Store already has countries (returning to page) — derive immediately
        this.deriveCountryState(this.props.countries);
      } else {
        this.props.fetchCountries();
      }
    } else {
      this.props.history.push("/login");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.countries !== this.props.countries) {
      this.deriveCountryState(this.props.countries);
    }
  }
  getsetting = () => {
    this.setLoader(true);
    const currentUserId = getLocalStorage("id");

    delivaApiService("getSetting", { userId: currentUserId })
      .then((response) => {
        if (response && response.data) {
          const providerCountriesData =
            response?.data?.providerCountries || response?.data || {};
          const normalizedProviderSettings = this.normalizeProviderCountries(
            providerCountriesData,
          );

          this.setState(
            {
              paymentCycle: response.data.paymentCycle,
              delivaCommission: response.data.delivaCommission,
              paCommission: response.data.paCommission,
              protectYourPackage: response.data.protectYourPackage,
              country: response?.data?.country,
              deliveryRequestPickupRadius:
                response.data.deliveryRequestPickupRadius,
              distanceNearby: response.data.nearbyDistance || "",
              distanceShort: response.data.shortDistance || "",
              distanceLong: response.data.longDistance || "",
              radiusUnit: response.data.radiusUnit.toLowerCase(),
              isTwilioOn: response.data.twilioOn,
              twilioOnTimeInHours: response.data.twilioOnTimeInHours,
              twilioMessage: response.data.twilioMessage,
              smsProvider: response.data.smsProvider || "TERMI",
              documentationType: response.data.documentationType,
              kycProvider: response.data.documentationType?.replace(
                "_DOCUMENTATION",
                "",
              ),
              isFavouritedEnable: response.data.favouritedEnable,
              routeSubscriptionLimit: response.data.routeSubscriptionLimit,
              routeCreateLimit: response.data.routeCreateLimit,
              routeCreateInMonth: response.data.routeCreateInMonth,
              providerCountries: normalizedProviderSettings.providerCountries,
              paymentCountries: normalizedProviderSettings.paymentCountries,
              kycCountries: normalizedProviderSettings.kycCountries,
              smsCountries: normalizedProviderSettings.smsCountries,
              paymentProvider: response.data.paymentProvider || "STRIPE",
            },
            () => {
              this.setLoader(false);
            },
          );
        } else {
          this.setLoader(false);
        }
      })
      .catch((error) => {
        this.setLoader(false);
      });
  };
  update() {}

  getAvailableCountries = (category, currentProvider) => {
    const {
      providerCountryOptionsByCategory,
      smsCountries,
      kycCountries,
      paymentCountries,
    } = this.state;

    const providerMap =
      category === "SMS"
        ? smsCountries
        : category === "KYC"
          ? kycCountries
          : paymentCountries;

    // Countries assigned to other providers
    const usedByOthers = Object.entries(providerMap)
      .filter(([provider]) => provider !== currentProvider)
      .flatMap(([, countries]) => countries);

    return (providerCountryOptionsByCategory[category] || []).filter(
      (country) =>
        !usedByOthers.includes(country.value) ||
        (providerMap[currentProvider] || []).includes(country.value),
    );
  };

  fetchProviderCountryOptions = (category, force = false) => {
    const categoryKey = category.toUpperCase();

    const existing = this.state.providerCountryOptionsByCategory[categoryKey];

    if (!force && existing?.length) {
      return;
    }

    this.setState((prevState) => ({
      providerCountryOptionsLoadingByCategory: {
        ...prevState.providerCountryOptionsLoadingByCategory,
        [categoryKey]: true,
      },
    }));

    delivaApiService("getCountriesWithUnitsAdmin", { category: categoryKey })
      .then((response) => {
        const resourceData = response?.data?.resourceData || [];
        const providerCountryOptions = normalizeCountryOptions(resourceData);
        this.setState((prevState) => ({
          providerCountryOptionsByCategory: {
            ...prevState.providerCountryOptionsByCategory,
            [categoryKey]: providerCountryOptions,
          },
          providerCountryOptionsLoadingByCategory: {
            ...prevState.providerCountryOptionsLoadingByCategory,
            [categoryKey]: false,
          },
        }));
      })
      .catch(() => {
        this.setState((prevState) => ({
          providerCountryOptionsLoadingByCategory: {
            ...prevState.providerCountryOptionsLoadingByCategory,
            [categoryKey]: false,
          },
        }));
      });
  };

  setLoader(showLoader) {
    this.setState({
      showLoader,
    });
  }

  handleLogout() {
    clearLocalStorage();
    this.props.history.push("/login");
  }

  normalizeProviderCountries = (providerCountriesData) => {
    const paymentCountries = {
      STRIPE: [],
      FLUTTERWAVE: [],
      PAYSTACK: [],
    };
    const smsCountries = {
      TERMI: [],
      DOJAH: [],
      TWILIO: [],
    };
    const kycCountries = {
      DOJAH: [],
      SUMSUB: [],
      MANUAL: [],
    };

    const normalizedData =
      providerCountriesData && typeof providerCountriesData === "object"
        ? providerCountriesData
        : {};

    const paymentSection =
      normalizedData.PAYMENT || normalizedData.payment || {};
    const kycSection = normalizedData.KYC || normalizedData.kyc || {};
    const smsSection = normalizedData.SMS || normalizedData.sms || {};

    Object.entries(paymentSection).forEach(([provider, config]) => {
      const normalizedProvider = provider.toUpperCase();
      if (paymentCountries[normalizedProvider] !== undefined) {
        paymentCountries[normalizedProvider] = config?.countryNames || [];
      }
    });

    Object.entries(kycSection).forEach(([provider, config]) => {
      const normalizedProvider = provider.toUpperCase();
      if (kycCountries[normalizedProvider] !== undefined) {
        kycCountries[normalizedProvider] = config?.countryNames || [];
      }
    });

    Object.entries(smsSection).forEach(([provider, config]) => {
      const normalizedProvider = provider.toUpperCase();
      if (smsCountries[normalizedProvider] !== undefined) {
        smsCountries[normalizedProvider] = config?.countryNames || [];
      }
    });

    return {
      paymentCountries,
      kycCountries,
      smsCountries,
      providerCountries: providerCountriesData || [],
    };
  };

  getCountryIdMap = () => {
    const countryMap = new Map();

    (this.props.countries || []).forEach((country) => {
      const countryId =
        country.countryId ||
        country.id ||
        country.country_id ||
        country.countryID;
      const countryName = country.countryName || country.name;

      if (countryId && countryName) {
        countryMap.set(countryName, countryId);
      }
    });

    (this.state.countryOptions || []).forEach((option) => {
      if (!countryMap.has(option.value) && option.countryId) {
        countryMap.set(option.value, option.countryId);
      }
    });

    return countryMap;
  };

  getCountryIds = (countries = []) => {
    const countryMap = this.getCountryIdMap();

    return [
      ...new Set(
        (countries || [])
          .map((country) => countryMap.get(country))
          .filter((countryId) => countryId !== undefined && countryId !== null),
      ),
    ];
  };

  buildKycProviderCountriesPayload = () => {
    return Object.entries(this.state.kycCountries || {}).map(
      ([provider, countries]) => ({
        category: "KYC",
        provider,
        countryIds: this.getCountryIds(countries),
      }),
    );
  };

  buildSmsProviderCountriesPayload = () => {
    return Object.entries(this.state.smsCountries || {}).map(
      ([provider, countries]) => ({
        category: "SMS",
        provider,
        countryIds: this.getCountryIds(countries),
      }),
    );
  };

  buildProviderCountriesPayload = () => {
    const paymentProviders = Object.entries(
      this.state.paymentCountries || {},
    ).map(([provider, countries]) => ({
      category: "PAYMENT",
      provider,
      countryIds: this.getCountryIds(countries),
    }));

    return [
      ...this.buildKycProviderCountriesPayload(),
      ...this.buildSmsProviderCountriesPayload(),
      ...paymentProviders,
    ];
  };

  checkCountryRequirements = (category) => {
    let requiredProviders = this.buildProviderCountriesPayload()
      .filter(
        ({ category: itemCategory, countryIds, provider }) =>
          itemCategory === category &&
          provider !== "MANUAL" &&
          (!Array.isArray(countryIds) || countryIds.length === 0),
      )
      .map(({ provider }) => provider);

    if (requiredProviders.includes("PAYSTACK")) {
      requiredProviders = [
        "PAYSTACK",
        ...requiredProviders.filter((provider) => provider !== "PAYSTACK"),
      ];
    }

    if (!requiredProviders.length) return false;

    const providers = requiredProviders.map(toTitleCase);

    const providerText =
      providers.length === 1
        ? providers[0]
        : `${providers.slice(0, -1).join(", ")} and ${providers.at(-1)}`;

    showErrorToast(`A country must be selected for ${providerText}.`);

    this.getsetting();

    return true;
  };

  handleUpdate = (type, val) => {
    let data = {};

    if (type === "isTwilioOn") {
      if (this.checkCountryRequirements("SMS")) return;
      data = {
        twilioOnTimeInHours: !this.state.isTwilioOn
          ? ""
          : parseInt(this.state.twilioOnTimeInHours),
        isTwilioOn: this.state.isTwilioOn,
        smsProvider: this.state.smsProvider,
        smsProviderCountries: this.buildSmsProviderCountriesPayload(),
        providerCountries: this.buildProviderCountriesPayload(),
      };
    } else if (type === "deliveryRequestPickupRadius") {
      data = {
        deliveryRequestPickupRadius: parseInt(
          this.state.deliveryRequestPickupRadius,
        ),
        radiusUnit: this.state.radiusUnit,
      };
    } else if (type === "documentationType") {
      if (this.checkCountryRequirements("KYC")) return;

      data = {
        documentationType: this.state.documentationType,
        providerCountries: this.buildProviderCountriesPayload(),
        // kycProviderCountries: this.buildKycProviderCountriesPayload(),
      };
    } else if (type === "protectYourPackage") {
      data = {
        protectYourPackage: this.state.protectYourPackage,
      };
    } else if (type === "isFavouritedEnable") {
      data = {
        isFavouritedEnable: this.state.isFavouritedEnable,
      };
    } else if (type === "routeCreateLimit") {
      const limit = parseInt(this.state.routeCreateLimit, 10);
      const month = parseInt(this.state.routeCreateInMonth, 10);

      if (isNaN(month) || month > 12) {
        showErrorToast("Month should not be more than 12.");
        return;
      }

      data = {
        routeCreateLimit: limit,
        routeCreateInMonth: month,
      };
    } else if (type === "country") {
      data = {
        country: this.state.country,
      };
    } else {
      data = {
        [type]: parseInt(val),
      };
    }

    this.setLoader(true);
    delivaApiService([type], data)
      .then((response) => {
        if (response && response.data) {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.responseMessage);
          }
          this.getsetting();
          if (type === "isTwilioOn") {
            this.fetchProviderCountryOptions("SMS", true);
          }

          if (type === "documentationType") {
            this.fetchProviderCountryOptions("KYC", true);
          }
        } else {
          this.setLoader(false);
        }
      })
      .catch((error) => {
        this.setLoader(false);
      });
  };

  handleUpdateDistanceFilter = () => {
    if (!this.state.distanceNearby) {
      showErrorToast("Please enter nearby distance value.");
      return;
    }

    const data = {
      nearbyDistance: parseInt(this.state.distanceNearby, 10),
      shortDistance: parseInt(this.state.distanceShort, 10) || 0,
      longDistance: parseInt(this.state.distanceLong, 10) || 0,
      unit: this.state.unit,
    };

    this.setLoader(true);
    delivaApiService("deliveryDistanceFilter", data)
      .then((response) => {
        if (response && response.data) {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.responseMessage);
            this.setLoader(false);
          } else {
            this.getsetting();
          }
        } else {
          this.setLoader(false);
        }
      })
      .catch((error) => {
        this.setLoader(false);
      });
  };

  handleChange = (type, event) => {
    let value = event?.target?.value || "";

    const isRadiusUnit = type === "radiusUnit";
    const isUnit = type === "unit";
    const isTwilioHours = type === "twilioOnTimeInHours";

    if (type === "isFavouritedEnable") {
      this.setState((prevState) => ({
        [type]: !prevState.isFavouritedEnable,
      }));
      return;
    }

    if (isTwilioHours) {
      const numericValue = value.replace(/[^0-9]/g, "");
      this.setState({ [type]: numericValue });
    } else if (isRadiusUnit || isUnit) {
      this.setState({ [type]: value });
    } else {
      const numericValue = value.replace(/[^0-9]/g, "");
      this.setState({ [type]: numericValue });
    }
  };

  handleSearchFocus = () => {
    this.setState({ dropdownOpen: true });
  };

  handleCountrySearchChange = (e) => {
    this.setState({ countrySearch: e.target.value, dropdownOpen: true });
  };

  handleCountrySelect = (country) => {
    if (!this.state.country.includes(country)) {
      this.setState((prevState) => ({
        country: [...prevState.country, country],
        countrySearch: "",
        dropdownOpen: false,
      }));
    }
  };

  removeSelectedCountry = (countryToRemove) => {
    this.setState((prevState) => ({
      country: prevState.country.filter((c) => c !== countryToRemove),
    }));
  };

  handleClickOutside = (e) => {
    if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
      this.setState({ dropdownOpen: false });
    }

    if (
      this.paymentDropdownRef &&
      !this.paymentDropdownRef.contains(e.target)
    ) {
      this.setState({
        paymentDropdownOpen: false,
        paymentCountrySearch: "",
      });
    }

    if (this.smsDropdownRef && !this.smsDropdownRef.contains(e.target)) {
      this.setState({
        smsDropdownOpen: false,
        smsCountrySearch: "",
      });
    }

    if (this.kycDropdownRef && !this.kycDropdownRef.contains(e.target)) {
      this.setState({
        kycDropdownOpen: false,
        kycCountrySearch: "",
      });
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  openDropdown = () => {
    // start with currently saved countries as the working selection
    this.setState({
      dropdownOpen: true,
      tempSelectedCountries: [...this.state.country],
    });
  };

  handleToggleTempCountry = (value) => {
    this.setState((prev) => {
      const exists = prev.tempSelectedCountries.includes(value);
      return {
        tempSelectedCountries: exists
          ? prev.tempSelectedCountries.filter((c) => c !== value)
          : [...prev.tempSelectedCountries, value],
      };
    });
  };

  handleAddCountries = () => {
    // commit working selection to actual list
    this.setState((prev) => ({
      country: [...new Set(prev.tempSelectedCountries)],
      dropdownOpen: false,
      countrySearch: "",
    }));
  };

  handleCancelCountries = () => {
    // discard working selection
    this.setState({
      dropdownOpen: false,
      countrySearch: "",
      tempSelectedCountries: [...this.state.country],
    });
  };

  promptRemoveCountry = (countryToRemove) => {
    this.setState({ showRemoveModal: true, countryToRemove });
  };

  confirmRemoveCountry = () => {
    const { countryToRemove } = this.state;
    this.setState((prev) => ({
      country: prev.country.filter((c) => c !== countryToRemove),
      showRemoveModal: false,
      countryToRemove: null,
    }));
  };

  closeRemoveModal = () => {
    this.setState({ showRemoveModal: false, countryToRemove: null });
  };

  handlePaymentProviderChange = (provider) => {
    this.setState((prev) => ({
      paymentProvider: provider,
      paymentTempSelected: [...prev.paymentCountries[provider]],
      paymentDropdownOpen: false,
      paymentCountrySearch: "",
    }));
  };

  handlePaymentCountrySelect = (country) => {
    this.setState((prev) => {
      const alreadySelected = prev.paymentTempSelected.includes(country);
      return {
        paymentTempSelected: alreadySelected
          ? prev.paymentTempSelected.filter((c) => c !== country)
          : [...prev.paymentTempSelected, country],
      };
    });
  };

  handlePaymentDropdownOpen = () => {
    this.fetchProviderCountryOptions("PAYMENT");
    const { paymentProvider, paymentCountries } = this.state;
    this.setState({
      paymentDropdownOpen: true,
      paymentTempSelected: [...(paymentCountries[paymentProvider] || [])],
      paymentCountrySearch: "",
    });
  };

  handlePaymentAddCountries = () => {
    const { paymentProvider, paymentTempSelected } = this.state;
    this.setState((prev) => ({
      paymentCountries: {
        ...prev.paymentCountries,
        [paymentProvider]: [...new Set(paymentTempSelected)],
      },
      paymentDropdownOpen: false,
      paymentCountrySearch: "",
    }));
  };

  handlePaymentCancelCountries = () => {
    this.setState({ paymentDropdownOpen: false, paymentCountrySearch: "" });
  };

  removePaymentCountry = (provider, country) => {
    this.setState((prev) => {
      const sorted = sortedCountries([
        ...(prev.providerCountryOptionsByCategory?.PAYMENT || []),
        ...this.state.countryOptions.filter((c) => c.value === country),
      ]);
      return {
        paymentCountries: {
          ...prev.paymentCountries,
          [provider]: prev.paymentCountries[provider].filter(
            (c) => c !== country,
          ),
        },
        providerCountryOptionsByCategory: {
          PAYMENT: sorted,
        },
      };
    });
  };

  handleSmsCountrySelect = (country) => {
    this.setState((prev) => {
      const alreadySelected = prev.smsTempSelected.includes(country);
      return {
        smsTempSelected: alreadySelected
          ? prev.smsTempSelected.filter((c) => c !== country)
          : [...prev.smsTempSelected, country],
      };
    });
  };

  handleSmsDropdownOpen = () => {
    this.fetchProviderCountryOptions("SMS");
    const { smsProvider, smsCountries } = this.state;
    this.setState({
      smsDropdownOpen: true,
      smsTempSelected: [...(smsCountries[smsProvider] || [])],
      smsCountrySearch: "",
    });
  };

  handleSmsAddCountries = () => {
    const { smsProvider, smsTempSelected } = this.state;
    this.setState((prev) => ({
      smsCountries: {
        ...prev.smsCountries,
        [smsProvider]: [...new Set(smsTempSelected)],
      },
      smsDropdownOpen: false,
      smsCountrySearch: "",
    }));
  };

  handleSmsCancelCountries = () => {
    this.setState({ smsDropdownOpen: false, smsCountrySearch: "" });
  };

  removeSmsCountry = (provider, country) => {
    this.setState((prev) => {
      const sorted = sortedCountries([
        ...(prev.providerCountryOptionsByCategory?.SMS || []),
        ...this.state.countryOptions.filter((c) => c.value === country),
      ]);

      return {
        smsCountries: {
          ...prev.smsCountries,
          [provider]: prev.smsCountries[provider].filter((c) => c !== country),
        },
        providerCountryOptionsByCategory: {
          SMS: sorted,
        },
      };
    });
  };

  handleKycProviderChange = (provider) => {
    this.setState((prev) => ({
      kycProvider: provider,
      kycTempSelected: [...prev.kycCountries[provider]],
      kycDropdownOpen: false,
      kycCountrySearch: "",
    }));
    this.setState({
      documentationType:
        provider === "DOJAH"
          ? "DOJAH_DOCUMENTATION"
          : provider === "SUMSUB"
            ? "SUMSUB_DOCUMENTATION"
            : "MANUAL_DOCUMENTATION",
    });
  };

  handleKycCountrySelect = (country) => {
    this.setState((prev) => {
      const alreadySelected = prev.kycTempSelected.includes(country);
      return {
        kycTempSelected: alreadySelected
          ? prev.kycTempSelected.filter((c) => c !== country)
          : [...prev.kycTempSelected, country],
      };
    });
  };

  handleKycDropdownOpen = () => {
    this.fetchProviderCountryOptions("KYC");
    const { kycProvider, kycCountries } = this.state;
    this.setState({
      kycDropdownOpen: true,
      kycTempSelected: [...(kycCountries[kycProvider] || [])],
      kycCountrySearch: "",
    });
  };

  handleKycAddCountries = () => {
    const { kycProvider, kycTempSelected } = this.state;
    this.setState((prev) => ({
      kycCountries: {
        ...prev.kycCountries,
        [kycProvider]: [...new Set(kycTempSelected)],
      },
      kycDropdownOpen: false,
      kycCountrySearch: "",
    }));
  };

  handleKycCancelCountries = () => {
    this.setState({ kycDropdownOpen: false, kycCountrySearch: "" });
  };

  removeKycCountry = (provider, country) => {
    this.setState((prev) => {
      const sorted = sortedCountries([
        ...(prev.providerCountryOptionsByCategory?.KYC || []),
        ...this.state.countryOptions.filter((c) => c.value === country),
      ]);
      return {
        kycCountries: {
          ...prev.kycCountries,
          [provider]: prev.kycCountries[provider].filter((c) => c !== country),
        },
        providerCountryOptionsByCategory: {
          KYC: sorted,
        },
      };
    });
  };

  handlePaymentApply = () => {
    if (this.checkCountryRequirements("PAYMENT")) return;
    const data = {
      paymentProvider: this.state.paymentProvider,
      // paymentCountries: this.state.paymentCountries,
      providerCountries: this.buildProviderCountriesPayload(),
    };
    this.setLoader(true);
    delivaApiService("paymentProviderSetting", data)
      .then((response) => {
        if (response && response.data) {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.responseMessage);
          }
          this.getsetting();
          this.fetchProviderCountryOptions("PAYMENT", true);
        } else {
          this.setLoader(false);
        }
      })
      .catch(() => {
        this.setLoader(false);
      });
  };

  // renderRadioOption = (value, label, id) => (
  //   <div className="checkboxContainer">
  //     <input
  //       type="radio"
  //       id={id}
  //       name="documentationType"
  //       value={value}
  //       checked={this.state.documentationType === value}
  //       onChange={this.handleManualChange}
  //     />
  //     <label htmlFor={id} className="input-label">
  //       {label}
  //     </label>
  //   </div>
  // );

  handleManualChange = (event) => {
    const value = event.target.value;
    this.setState({ documentationType: value });
  };

  render() {
    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />
        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3">
                    <Col md={6} lg={8} className="">
                      <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                        Application Level Settings{" "}
                      </h3>
                    </Col>
                  </Row>

                  <div className="setting-block p-4">
                    <div className="process-list">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 paradate text-capitalize">
                          SMS Service Provider
                        </h3>
                        <button
                          onClick={() =>
                            this.handleUpdate(
                              "isTwilioOn",
                              this.state.isTwilioOn,
                            )
                          }
                          className="btnDefault btnOutline"
                        >
                          Apply
                        </button>
                      </div>
                      <hr />

                      <div className="service-provider d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                          <p className="mb-1 fs14 darkgray-color">
                            Service provider
                          </p>
                          <div className="d-flex gap-3 mb-2">
                            <div className="checkboxContainer">
                              <input
                                type="radio"
                                id="smsRadio"
                                name="smsProvider"
                                checked={this.state.smsProvider === "TERMI"}
                                onChange={() => this.handleRadioChange("TERMI")}
                              />
                              <label htmlFor="smsRadio" className="input-label">
                                Termii
                              </label>
                            </div>
                            <div className="checkboxContainer">
                              <input
                                type="radio"
                                id="smsRadio1"
                                name="smsProvider"
                                checked={this.state.smsProvider === "DOJAH"}
                                onChange={() => this.handleRadioChange("DOJAH")}
                              />
                              <label
                                htmlFor="smsRadio1"
                                className="input-label"
                              >
                                Dojah
                              </label>
                            </div>
                            <div className="checkboxContainer">
                              <input
                                type="radio"
                                id="smsRadio2"
                                name="smsProvider"
                                checked={this.state.smsProvider === "TWILIO"}
                                onChange={() =>
                                  this.handleRadioChange("TWILIO")
                                }
                              />
                              <label
                                htmlFor="smsRadio2"
                                className="input-label"
                              >
                                Twilio
                              </label>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{ minWidth: 250, position: "relative" }}
                          ref={(ref) => (this.smsDropdownRef = ref)}
                        >
                          <div
                            className="search-box px-2 py-1 d-flex align-items-center justify-content-between form-control"
                            style={{
                              cursor: "pointer",
                              border: "1px solid #bbbbbb",
                            }}
                            onClick={this.handleSmsDropdownOpen}
                          >
                            <input
                              type="text"
                              className="form-control border-0 shadow-none"
                              placeholder="Select country"
                              value={this.state.smsCountrySearch}
                              onChange={(e) =>
                                this.setState({
                                  smsCountrySearch: e.target.value,
                                })
                              }
                              onFocus={this.handleSmsDropdownOpen}
                              onClick={(e) => e.stopPropagation()}
                              style={{ minHeight: "48px" }}
                            />
                            <img
                              src={CaretDown}
                              alt="CaretDown"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleSmsDropdownOpen();
                              }}
                              style={{
                                paddingLeft: "6px",
                                paddingRight: "4px",
                                cursor: "pointer",
                                height: "14px",
                                width: "100px",
                                maxWidth: "max-content",
                              }}
                            />
                          </div>

                          {this.state.smsDropdownOpen && (
                            <div
                              className="shadow border rounded mt-1 country-multi-dropdown"
                              style={{
                                position: "absolute",
                                background: "#fff",
                                width: "100%",
                                maxWidth: "300px",
                                zIndex: 1000,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div
                                style={{
                                  maxHeight: "240px",
                                  overflowY: "auto",
                                }}
                              >
                                {this.state
                                  .providerCountryOptionsLoadingByCategory
                                  ?.SMS ? (
                                  <div className="px-3 py-2 text-muted small">
                                    Loading countries...
                                  </div>
                                ) : (
                                  (() => {
                                    const options = this.getAvailableCountries(
                                      "SMS",
                                      this.state.smsProvider,
                                    )?.filter((item) => {
                                      const s = this.state.smsCountrySearch
                                        ?.trim()
                                        ?.toLowerCase();
                                      return (
                                        !s ||
                                        item.label?.toLowerCase().includes(s)
                                      );
                                    });

                                    if (!options.length) {
                                      return (
                                        <div className="px-3 py-2 text-muted small">
                                          No countries found
                                        </div>
                                      );
                                    }

                                    return options.map((item) => {
                                      const checked =
                                        this.state.smsTempSelected.includes(
                                          item.value,
                                        );
                                      return (
                                        <label
                                          key={item.value}
                                          className="d-flex align-items-center px-3 py-2 border-bottom gap-2"
                                          style={{ cursor: "pointer" }}
                                          htmlFor={`sms-${item.value}`}
                                          onClick={() =>
                                            this.handleSmsCountrySelect(
                                              item.value,
                                            )
                                          }
                                        >
                                          <div className="checkboxContainer">
                                            <input
                                              id={`sms-${item.value}`}
                                              type="checkbox"
                                              className="countryCheckbox me-2"
                                              checked={checked}
                                              onChange={() =>
                                                this.handleSmsCountrySelect(
                                                  item.value,
                                                )
                                              }
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                              style={{
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </div>
                                          <span
                                            className="flex-grow-1"
                                            style={{ fontSize: "22px" }}
                                          >
                                            {item.label}
                                          </span>
                                        </label>
                                      );
                                    });
                                  })()
                                )}
                              </div>
                              <div className="d-flex justify-content-between align-items-center p-3 border-top bg-white">
                                <Button
                                  className="btnDefault settingDropDownBtn minw-100 btnOutline"
                                  onClick={this.handleSmsCancelCountries}
                                >
                                  Close
                                </Button>
                                <Button
                                  className="btnDefault btnPrimary settingDropDownBtn minw-100"
                                  onClick={this.handleSmsAddCountries}
                                >
                                  Add
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {[
                        { key: "TERMI", label: "Termii" },
                        { key: "DOJAH", label: "Dojah" },
                        { key: "TWILIO", label: "Twilio" },
                      ].map(({ key, label }) =>
                        this.state.smsCountries[key]?.length > 0 ? (
                          <div
                            key={key}
                            className={`payment-provider-row mt-3 p-3 ${this.state.smsProvider !== key ? "opacity-half" : ""}`}
                            style={{
                              background: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            <h5 className="mb-2 paradate">{label}</h5>
                            <div>
                              {this.state.smsCountries[key].map((c) => (
                                <span
                                  key={c}
                                  style={{
                                    background: "#FFF3CD",
                                    color: "#856404",
                                    borderRadius: "16px",
                                    padding: "4px 12px",
                                    marginRight: "8px",
                                    marginBottom: "4px",
                                    display: "inline-block",
                                    fontSize: 15,
                                  }}
                                >
                                  {c}
                                  {this.state.smsProvider === key && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: 8,
                                        fontWeight: "bold",
                                      }}
                                      onClick={() =>
                                        this.removeSmsCountry(key, c)
                                      }
                                    >
                                      ×
                                    </span>
                                  )}
                                </span>
                              ))}
                            </div>
                          </div>
                        ) : null,
                      )}

                      {/* {this.state.isTwilioOn && (
                        <div className="inputBox d-flex align-items-center mt-3">
                          <span className="fs18 darkgray-color">Set for</span>
                          <input
                            className="form-control ml-2 text-center"
                            type="text"
                            maxlength="3"
                            size="3"
                            value={this.state.twilioOnTimeInHours}
                            style={{ maxWidth: "70px" }}
                            onChange={(e) =>
                              this.handleChange("twilioOnTimeInHours", e)
                            }
                          />
                          <span className="fs18 darkgray-color ml-2">
                            Hours
                          </span>
                        </div>
                      )} */}

                      {/* <span className="fs18 darkgray-color">
                        {this.state.isTwilioOn && this.state.twilioMessage}
                      </span> */}
                    </div>

                    {/* <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <h3 className="mb-0 paradate text-capitalize">
                            KYC verification from
                          </h3>
                        </Col>
                        <Col lg={5}>
                          <div className="d-flex gap-3">
                            {this.renderRadioOption(
                              "DOJAH_DOCUMENTATION",
                              "Other",
                              "smsRadio3",
                            )}
                            {this.renderRadioOption(
                              "MANUAL_DOCUMENTATION",
                              "Manual",
                              "smsRadio4",
                            )}
                          </div>
                          {this.state.documentationType === "DOJAH_DOCUMENTATION" && (
                            <p className="mb-0 mt-2 fs14 darkgray-color">
                              KYC Provider: Dojah (Nigeria), Sumsub (US)
                            </p>
                          )}
                        </Col>

                        <Col lg={2} className="text-right">
                          <button
                            onClick={() =>
                              this.handleUpdate(
                                "documentationType",
                                this.state.documentationType,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div> */}

                    {/* ── KYC Verification ── */}
                    <div className="process-list">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 paradate text-capitalize">
                          KYC verification from
                        </h3>
                        <button
                          // onClick={this.handlePaymentApply}
                          onClick={() =>
                            this.handleUpdate(
                              "documentationType",
                              this.state.documentationType,
                            )
                          }
                          className="btnDefault btnOutline"
                        >
                          Apply
                        </button>
                      </div>
                      <hr />

                      <div className="service-provider d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                          <p className="mb-1 fs14 darkgray-color">
                            Service provider
                          </p>
                          <div className="d-flex gap-3 mb-2">
                            {[
                              { value: "DOJAH", label: "Dojah" },
                              { value: "SUMSUB", label: "Sumsub" },
                              { value: "MANUAL", label: "Manual" },
                            ].map(({ value, label }) => (
                              <div className="checkboxContainer" key={value}>
                                <input
                                  type="radio"
                                  id={`kycProvider_${value}`}
                                  name="kycProvider"
                                  value={value}
                                  checked={this.state.documentationType?.includes(
                                    value,
                                  )}
                                  onChange={() =>
                                    this.handleKycProviderChange(value)
                                  }
                                />
                                <label
                                  htmlFor={`kycProvider_${value}`}
                                  className="input-label"
                                >
                                  {label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Country picker */}
                        <div
                          style={{ minWidth: 250, position: "relative" }}
                          ref={(ref) => (this.kycDropdownRef = ref)}
                        >
                          <div
                            className="search-box px-2 py-1 d-flex align-items-center justify-content-between form-control"
                            style={{
                              cursor: "pointer",
                              border: "1px solid #bbbbbb",
                            }}
                            onClick={this.handleKycDropdownOpen}
                          >
                            <input
                              type="text"
                              className="form-control border-0 shadow-none"
                              placeholder="Select country"
                              value={this.state.kycCountrySearch}
                              onChange={(e) =>
                                this.setState({
                                  kycCountrySearch: e.target.value,
                                })
                              }
                              onFocus={this.handleKycDropdownOpen}
                              onClick={(e) => e.stopPropagation()}
                              style={{ minHeight: "48px" }}
                            />
                            <img
                              src={CaretDown}
                              alt="CaretDown"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleKycDropdownOpen();
                              }}
                              style={{
                                paddingLeft: "6px",
                                paddingRight: "4px",
                                cursor: "pointer",
                                height: "14px",
                                width: "100px",
                                maxWidth: "max-content",
                              }}
                            />
                          </div>

                          {this.state.kycDropdownOpen && (
                            <div
                              className="shadow border rounded mt-1 country-multi-dropdown"
                              style={{
                                position: "absolute",
                                background: "#fff",
                                width: "100%",
                                maxWidth: "300px",
                                zIndex: 1000,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div
                                style={{
                                  maxHeight: "240px",
                                  overflowY: "auto",
                                }}
                              >
                                {this.state
                                  .providerCountryOptionsLoadingByCategory
                                  ?.KYC ? (
                                  <div className="px-3 py-2 text-muted small">
                                    Loading countries...
                                  </div>
                                ) : (
                                  (() => {
                                    const options = this.getAvailableCountries(
                                      "KYC",
                                      this.state.kycProvider,
                                    )?.filter((item) => {
                                      const s = this.state.kycCountrySearch
                                        ?.trim()
                                        ?.toLowerCase();
                                      return (
                                        !s ||
                                        item.label?.toLowerCase().includes(s)
                                      );
                                    });

                                    if (!options.length) {
                                      return (
                                        <div className="px-3 py-2 text-muted small">
                                          No countries found
                                        </div>
                                      );
                                    }

                                    return options.map((item) => {
                                      const checked =
                                        this.state.kycTempSelected.includes(
                                          item.value,
                                        );
                                      return (
                                        <label
                                          key={item.value}
                                          className="d-flex align-items-center px-3 py-2 border-bottom gap-2"
                                          style={{ cursor: "pointer" }}
                                          htmlFor={`kyc-${item.value}`}
                                          onClick={() =>
                                            this.handleKycCountrySelect(
                                              item.value,
                                            )
                                          }
                                        >
                                          <div className="checkboxContainer">
                                            <input
                                              id={`kyc-${item.value}`}
                                              type="checkbox"
                                              className="countryCheckbox me-2"
                                              checked={checked}
                                              onChange={() =>
                                                this.handleKycCountrySelect(
                                                  item.value,
                                                )
                                              }
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                              style={{
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </div>
                                          <span
                                            className="flex-grow-1"
                                            style={{ fontSize: "22px" }}
                                          >
                                            {item.label}
                                          </span>
                                        </label>
                                      );
                                    });
                                  })()
                                )}
                              </div>
                              <div className="d-flex justify-content-between align-items-center p-3 border-top bg-white">
                                <Button
                                  className="btnDefault settingDropDownBtn minw-100 btnOutline"
                                  onClick={this.handleKycCancelCountries}
                                >
                                  Close
                                </Button>
                                <Button
                                  className="btnDefault btnPrimary settingDropDownBtn minw-100"
                                  onClick={this.handleKycAddCountries}
                                >
                                  Add
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {[
                        { key: "DOJAH", label: "Dojah" },
                        { key: "SUMSUB", label: "Sumsub" },
                        { key: "MANUAL", label: "Manual" },
                      ].map(({ key, label }) =>
                        this.state.kycCountries[key]?.length > 0 ? (
                          <div
                            key={key}
                            className={`payment-provider-row mt-3 p-3 ${
                              !this.state.documentationType.includes(key)
                                ? "opacity-half"
                                : ""
                            }`}
                            style={{
                              background: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            <h5 className="mb-2 paradate">{label}</h5>
                            <div>
                              {this.state.kycCountries[key].map((c) => (
                                <span
                                  key={c}
                                  style={{
                                    background: "#FFF3CD",
                                    color: "#856404",
                                    borderRadius: "16px",
                                    padding: "4px 12px",
                                    marginRight: "8px",
                                    marginBottom: "4px",
                                    display: "inline-block",
                                    fontSize: 15,
                                  }}
                                >
                                  {c}

                                  {this.state.documentationType.includes(
                                    key,
                                  ) && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: 8,
                                        fontWeight: "bold",
                                      }}
                                      onClick={() =>
                                        this.removeKycCountry(key, c)
                                      }
                                    >
                                      ×
                                    </span>
                                  )}
                                </span>
                              ))}
                            </div>
                          </div>
                        ) : null,
                      )}
                    </div>

                    {/* ── Payment Provider ── */}
                    <div className="process-list">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 paradate text-capitalize">
                          Payment
                        </h3>
                        <button
                          onClick={this.handlePaymentApply}
                          className="btnDefault btnOutline"
                        >
                          Apply
                        </button>
                      </div>
                      <hr />

                      <div className="service-provider d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                          <p className="mb-1 fs14 darkgray-color">
                            Service provider
                          </p>
                          <div className="d-flex gap-3">
                            {[
                              { value: "PAYSTACK", label: "Paystack" },
                              { value: "STRIPE", label: "Stripe" },
                              { value: "FLUTTERWAVE", label: "Flutterwave" },
                            ].map(({ value, label }) => (
                              <div className="checkboxContainer" key={value}>
                                <input
                                  type="radio"
                                  id={`paymentRadio_${value}`}
                                  name="paymentProvider"
                                  value={value}
                                  checked={this.state.paymentProvider === value}
                                  disabled={value === "FLUTTERWAVE"} // Remove this in future if flutterwave is enabled
                                  onChange={() =>
                                    this.handlePaymentProviderChange(value)
                                  }
                                />
                                <label
                                  htmlFor={`paymentRadio_${value}`}
                                  className="input-label"
                                >
                                  {label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Country picker */}
                        <div
                          style={{ minWidth: 250, position: "relative" }}
                          ref={(ref) => (this.paymentDropdownRef = ref)}
                        >
                          <div
                            className="search-box px-2 py-1 d-flex align-items-center justify-content-between form-control"
                            style={{
                              cursor: "pointer",
                              border: "1px solid #bbbbbb",
                            }}
                            onClick={this.handlePaymentDropdownOpen}
                          >
                            <input
                              type="text"
                              className="form-control border-0 shadow-none"
                              placeholder="Select country"
                              value={this.state.paymentCountrySearch}
                              onChange={(e) =>
                                this.setState({
                                  paymentCountrySearch: e.target.value,
                                })
                              }
                              onFocus={this.handlePaymentDropdownOpen}
                              onClick={(e) => e.stopPropagation()}
                              style={{ minHeight: "48px" }}
                            />
                            <img
                              src={CaretDown}
                              alt="CaretDown"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handlePaymentDropdownOpen();
                              }}
                              style={{
                                paddingLeft: "6px",
                                paddingRight: "4px",
                                cursor: "pointer",
                                height: "14px",
                                width: "100px",
                                maxWidth: "max-content",
                              }}
                            />
                          </div>

                          {this.state.paymentDropdownOpen && (
                            <div
                              className="shadow border rounded mt-1 country-multi-dropdown"
                              style={{
                                position: "absolute",
                                background: "#fff",
                                width: "100%",
                                maxWidth: "300px",
                                zIndex: 1000,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div
                                style={{
                                  maxHeight: "240px",
                                  overflowY: "auto",
                                }}
                              >
                                {this.state
                                  .providerCountryOptionsLoadingByCategory
                                  ?.PAYMENT ? (
                                  <div className="px-3 py-2 text-muted small">
                                    Loading countries...
                                  </div>
                                ) : (
                                  (() => {
                                    const options = this.getAvailableCountries(
                                      "PAYMENT",
                                      this.state.paymentProvider,
                                    )?.filter((item) => {
                                      const s = this.state.paymentCountrySearch
                                        ?.trim()
                                        ?.toLowerCase();
                                      return (
                                        !s ||
                                        item.label?.toLowerCase().includes(s)
                                      );
                                    });

                                    if (!options.length) {
                                      return (
                                        <div className="px-3 py-2 text-muted small">
                                          No countries found
                                        </div>
                                      );
                                    }

                                    return options.map((item) => {
                                      const checked =
                                        this.state.paymentTempSelected.includes(
                                          item.value,
                                        );
                                      return (
                                        <label
                                          key={item.value}
                                          className="d-flex align-items-center px-3 py-2 border-bottom gap-2"
                                          style={{ cursor: "pointer" }}
                                          htmlFor={`pc-${item.value}`}
                                          onClick={() =>
                                            this.handlePaymentCountrySelect(
                                              item.value,
                                            )
                                          }
                                        >
                                          <div className="checkboxContainer">
                                            <input
                                              id={`pc-${item.value}`}
                                              type="checkbox"
                                              className="countryCheckbox me-2"
                                              checked={checked}
                                              onChange={() =>
                                                this.handlePaymentCountrySelect(
                                                  item.value,
                                                )
                                              }
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                              style={{
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </div>
                                          <span
                                            className="flex-grow-1"
                                            style={{ fontSize: "22px" }}
                                          >
                                            {item.label}
                                          </span>
                                        </label>
                                      );
                                    });
                                  })()
                                )}
                              </div>
                              <div className="d-flex justify-content-between align-items-center p-3 border-top bg-white">
                                <Button
                                  className="btnDefault settingDropDownBtn minw-100 btnOutline"
                                  onClick={this.handlePaymentCancelCountries}
                                >
                                  Close
                                </Button>
                                <Button
                                  className="btnDefault btnPrimary settingDropDownBtn minw-100"
                                  onClick={this.handlePaymentAddCountries}
                                >
                                  Add
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Per-provider country tags */}
                      {[
                        { key: "PAYSTACK", label: "Paystack" },
                        { key: "STRIPE", label: "Stripe" },
                        { key: "FLUTTERWAVE", label: "Flutterwave" },
                      ].map(({ key, label }) =>
                        this.state.paymentCountries[key]?.length > 0 ? (
                          <div
                            key={key}
                            className={`payment-provider-row mt-3 p-3 ${this.state.paymentProvider !== key ? "opacity-half" : ""}`}
                            style={{
                              background: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            <h5 className="mb-2 paradate">{label}</h5>
                            <div>
                              {this.state.paymentCountries[key].map((c) => (
                                <span
                                  key={c}
                                  style={{
                                    background: "#FFF3CD",
                                    color: "#856404",
                                    borderRadius: "16px",
                                    padding: "4px 12px",
                                    marginRight: "8px",
                                    marginBottom: "4px",
                                    display: "inline-block",
                                    fontSize: 15,
                                  }}
                                >
                                  {c}
                                  {this.state.paymentProvider === key && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: 8,
                                        fontWeight: "bold",
                                      }}
                                      onClick={() =>
                                        this.removePaymentCountry(key, c)
                                      }
                                    >
                                      ×
                                    </span>
                                  )}
                                </span>
                              ))}
                            </div>
                          </div>
                        ) : null,
                      )}
                    </div>

                    <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <h3 className="mb-0 paradate text-capitalize">
                            DelivaHere commission
                          </h3>
                        </Col>
                        <Col lg={5}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              placeholder="Enter Number"
                              value={this.state.delivaCommission}
                              onChange={(e) =>
                                this.handleChange("delivaCommission", e)
                              }
                            />
                            <p className="paradate mb-0 minw-80 ml-3">%</p>
                          </div>
                        </Col>
                        <Col lg={2} className="text-right">
                          <button
                            disabled={!this.state.delivaCommission}
                            onClick={() =>
                              this.handleUpdate(
                                "delivaCommission",
                                this.state.delivaCommission,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>
                    <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <h3 className="mb-0 paradate text-capitalize">
                            Parcel centre partner commission
                          </h3>
                        </Col>
                        <Col lg={5}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              placeholder="Enter Number"
                              value={this.state.paCommission}
                              onChange={(e) =>
                                this.handleChange("paCommission", e)
                              }
                            />
                            <p className="paradate mb-0 minw-80 ml-3">%</p>
                          </div>
                        </Col>
                        <Col lg={2} className="text-right">
                          <button
                            disabled={!this.state.paCommission}
                            onClick={() =>
                              this.handleUpdate(
                                "paCommission",
                                this.state.paCommission,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>
                    <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <h3 className="mb-0 paradate text-capitalize">
                            Protect Your Package
                          </h3>
                        </Col>
                        <Col lg={5}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              placeholder="Enter Number"
                              value={this.state.protectYourPackage}
                              onChange={(e) =>
                                this.handleChange("protectYourPackage", e)
                              }
                            />
                            <p className="paradate mb-0 minw-80 ml-3">%</p>
                          </div>
                        </Col>
                        <Col lg={2} className="text-right">
                          <button
                            disabled={!this.state.protectYourPackage}
                            onClick={() =>
                              this.handleUpdate(
                                "protectYourPackage",
                                this.state.protectYourPackage,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>
                    <div className="process-list ">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <h3 className="mb-0 paradate text-capitalize">
                            Payment cycle
                          </h3>
                        </Col>
                        <Col lg={5}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              placeholder="Enter Number"
                              value={this.state.paymentCycle}
                              onChange={(e) =>
                                this.handleChange("paymentCycle", e)
                              }
                            />
                            <p className="paradate mb-0 minw-80 ml-3">Days</p>
                          </div>
                        </Col>
                        <Col lg={2} className="text-right">
                          <button
                            disabled={!this.state.paymentCycle}
                            onClick={() =>
                              this.handleUpdate(
                                "paymentCycle",
                                this.state.paymentCycle,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>

                    <div className="process-list deliveryUnitdropdown">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <div className="d-flex align-items-center mb-0 position-relative">
                            <h3 className="paradate text-capitalize mb-0 me-2">
                              Set radius of delivery
                            </h3>

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id="tooltip-top"
                                  style={{ width: "347px" }}
                                >
                                  Set radius of delivery request visibility to
                                  the delivery partner
                                </Tooltip>
                              }
                            >
                              <img
                                src={tooltip}
                                alt="tooltip"
                                className="tooltip-icon ms-2 "
                              />
                            </OverlayTrigger>
                          </div>
                        </Col>

                        <Col lg={5}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              value={this.state.deliveryRequestPickupRadius}
                              onChange={(e) =>
                                this.handleChange(
                                  "deliveryRequestPickupRadius",
                                  e,
                                )
                              }
                              className="me-2"
                            />

                            <Select
                              labelId="role-lbl"
                              id="newRole"
                              value={this.state.radiusUnit}
                              onChange={(e) =>
                                this.handleChange("radiusUnit", e)
                              }
                              variant="filled"
                            >
                              {this.state.distanceUnits.map((unit) => (
                                <MenuItem
                                  key={unit}
                                  value={unit.toLowerCase()}
                                  className="FontSIze"
                                >
                                  {unit}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        </Col>
                        <Col lg={2} className="text-right">
                          <button
                            disabled={!this.state.deliveryRequestPickupRadius}
                            onClick={() =>
                              this.handleUpdate(
                                "deliveryRequestPickupRadius",
                                this.state.deliveryRequestPickupRadius,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>

                    <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <div className="d-flex align-items-center mb-0 position-relative">
                            <h3 className="paradate text-capitalize mb-0 me-2">
                              Notify to favourite DP
                            </h3>
                          </div>
                        </Col>

                        <Col lg={5}>
                          <div className="d-flex aligh-items-center">
                            <span className="mr-2" style={{ fontSize: "20px" }}>
                              Off
                            </span>

                            <Form.Check
                              type="switch"
                              id="customSwitch2"
                              label=""
                              checked={this.state.isFavouritedEnable}
                              onChange={(e) =>
                                this.handleChange("isFavouritedEnable", e)
                              }
                              className="custom-switch-green"
                            />

                            <span style={{ fontSize: "20px" }}>On</span>
                          </div>
                        </Col>

                        <Col lg={2} className="text-right">
                          <button
                            onClick={() =>
                              this.handleUpdate(
                                "isFavouritedEnable",
                                this.state.isFavouritedEnable,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>

                    <div className="process-list countrySelectBox">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <div className="d-flex align-items-center mb-0 position-relative">
                            <h3 className="paradate text-capitalize mb-0 me-2">
                              DelivaHere is available on this country
                            </h3>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-country">
                                  DelivaHere operates in this country.
                                </Tooltip>
                              }
                            >
                              <img
                                src={tooltip}
                                alt="tooltip"
                                className="tooltip-icon ms-2"
                                style={{
                                  cursor: "pointer",
                                  width: 24,
                                  height: 24,
                                  marginLeft: 8,
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        </Col>

                        <Col lg={5}>
                          <div
                            style={{ minWidth: 250, position: "relative" }}
                            ref={(ref) => (this.dropdownRef = ref)}
                          >
                            <div
                              className="search-box px-2 py-1 d-flex align-items-center justify-content-between form-control"
                              style={{
                                cursor: "pointer",
                                border: "1px solid #bbbbbb",
                              }}
                              onClick={this.toggleDropdown}
                            >
                              <div className="d-flex align-items-center flex-grow-1">
                                <input
                                  type="text"
                                  className="form-control border-0 shadow-none"
                                  placeholder="Select country"
                                  value={this.state.countrySearch}
                                  onChange={this.handleCountrySearchChange}
                                  onFocus={this.openDropdown}
                                  style={{
                                    border: "1px solid #bbbbbb",
                                    minHeight: "48px",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </div>

                              <img
                                src={CaretDown}
                                alt="CaretDown"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.openDropdown();
                                }}
                                style={{
                                  paddingLeft: "6px",
                                  paddingRight: "4px",
                                  cursor: "pointer",
                                  height: "14px",
                                  width: "100px",
                                  maxWidth: "max-content",
                                }}
                              />
                            </div>

                            {this.state.dropdownOpen && (
                              <div
                                className="shadow border rounded mt-1 country-multi-dropdown"
                                style={{
                                  position: "absolute",
                                  background: "#fff",
                                  width: "100%",
                                  maxWidth: "300px",
                                  zIndex: 1000,
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {/* Scrollable list */}
                                <div
                                  style={{
                                    maxHeight: "240px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {this.state.countryOptions
                                    ?.filter((item) => {
                                      const s = this.state.countrySearch
                                        ?.trim()
                                        ?.toLowerCase();
                                      return (
                                        !s ||
                                        item.label?.toLowerCase().includes(s)
                                      );
                                    })
                                    .map((item) => {
                                      const checked =
                                        this.state.tempSelectedCountries.includes(
                                          item.value,
                                        );
                                      return (
                                        <label
                                          key={item.value}
                                          className="d-flex align-items-center px-3 py-2 border-bottom gap-2"
                                          style={{ cursor: "pointer" }}
                                          htmlFor={`cc-${item.value}`}
                                          onClick={() =>
                                            this.handleToggleTempCountry(
                                              item.value,
                                            )
                                          }
                                        >
                                          <div className="checkboxContainer">
                                            <input
                                              id={`cc-${item.value}`}
                                              type="checkbox"
                                              className="countryCheckbox me-2"
                                              checked={checked}
                                              onChange={() =>
                                                this.handleToggleTempCountry(
                                                  item.value,
                                                )
                                              }
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                              style={{
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </div>

                                          <span
                                            className="flex-grow-1"
                                            style={{ fontSize: "22px" }}
                                          >
                                            {item.label}
                                          </span>
                                        </label>
                                      );
                                    })}
                                </div>

                                {/* Footer buttons */}
                                <div className="d-flex justify-content-between align-items-center p-3 border-top bg-white">
                                  <Button
                                    className="btnDefault settingDropDownBtn minw-100 btnOutline"
                                    onClick={this.handleCancelCountries}
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    className="btnDefault btnPrimary settingDropDownBtn minw-100"
                                    onClick={this.handleAddCountries}
                                  >
                                    Add
                                  </Button>
                                </div>
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col lg={2} className="text-right">
                          <button
                            onClick={() =>
                              this.handleUpdate("country", this.state.country)
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>

                        <hr className="w-100 mt-3 mb-0" />

                        <div className="mt-1 ml-2">
                          {this.state.country.map((selectedCountry) => (
                            <span
                              key={selectedCountry}
                              style={{
                                background: "#FFF3CD",
                                color: "#856404",
                                borderRadius: "16px",
                                padding: "4px 12px",
                                marginRight: "8px",
                                marginBottom: "4px",
                                display: "inline-block",
                                fontSize: 15,
                              }}
                            >
                              {selectedCountry}
                              <span
                                style={{
                                  cursor: "pointer",
                                  marginLeft: 8,
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  this.promptRemoveCountry(selectedCountry)
                                }
                              >
                                ×
                              </span>
                            </span>
                          ))}
                        </div>
                      </Row>
                    </div>

                    <div className="process-list">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <div className="d-flex align-items-center mb-0 position-relative">
                            <h3 className="paradate text-capitalize mb-0 me-2">
                              Over all subscribers route{" "}
                            </h3>
                          </div>
                        </Col>

                        <Col lg={5}>
                          <Form.Control
                            value={this.state.routeSubscriptionLimit}
                            onChange={(e) =>
                              this.handleChange("routeSubscriptionLimit", e)
                            }
                            className="me-2"
                          />
                        </Col>

                        <Col lg={2} className="text-right">
                          <button
                            onClick={() =>
                              this.handleUpdate(
                                "routeSubscriptionLimit",
                                this.state.routeSubscriptionLimit,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>

                    <div className="process-list">
                      <Row className="d-flex align-items-center justify-content-between">
                        <Col lg={5}>
                          <div className="d-flex align-items-center mb-0 position-relative">
                            <h3 className="paradate text-capitalize mb-0 me-2">
                              Create routes Counts
                            </h3>
                          </div>
                        </Col>

                        <Col lg={5}>
                          <div
                            className="d-flex align-items-center "
                            style={{ gap: "15px" }}
                          >
                            <Form.Control
                              value={this.state.routeCreateLimit}
                              onChange={(e) =>
                                this.handleChange("routeCreateLimit", e)
                              }
                            />
                            <Form.Control
                              type="text"
                              value={this.state.routeCreateInMonth}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,3}$/.test(value)) {
                                  this.handleChange("routeCreateInMonth", e);
                                }
                              }}
                            />
                            <div className="d-flex align-items-center">
                              <h3
                                className="paradate text-capitalize mb-0 me-2"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Month
                              </h3>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id="tooltip-top"
                                    style={{ width: "347px" }}
                                  >
                                    Set a timeline to create further routes
                                  </Tooltip>
                                }
                              >
                                <img
                                  src={tooltip}
                                  alt="tooltip"
                                  className="tooltip-icon ms-2"
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                        </Col>

                        <Col lg={2} className="text-right">
                          <button
                            onClick={() =>
                              this.handleUpdate(
                                "routeCreateLimit",
                                this.state.routeCreateLimit,
                              )
                            }
                            className="btnDefault btnOutline"
                          >
                            Apply
                          </button>
                        </Col>
                      </Row>
                    </div>

                    <div className="process-list deliveryUnitdropdown">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 paradate text-capitalize">
                          Delivery Distance Filter
                        </h3>
                        <button
                          onClick={this.handleUpdateDistanceFilter}
                          className="btnDefault btnOutline"
                          disabled={!this.state.distanceNearby}
                        >
                          Apply
                        </button>
                      </div>
                      <hr />

                      <div className="service-provider justify-content-between">
                        <div className="d-flex gap-3">
                          <div className="inputBox d-flex  align-items-center">
                            <span className="fs18 darkgray-color w-100">
                              Near By
                            </span>
                            <input
                              className="form-control "
                              type="text"
                              maxlength="3"
                              size="3"
                              value={this.state.distanceNearby}
                              onChange={(e) =>
                                this.handleChange("distanceNearby", e)
                              }
                              style={{ maxWidth: "150px" }}
                            />
                          </div>

                          <div className="inputBox d-flex ml-5  align-items-center">
                            <span className="fs18 darkgray-color w-100">
                              Short
                            </span>
                            <input
                              className="form-control "
                              type="text"
                              maxlength="3"
                              size="3"
                              value={this.state.distanceShort}
                              onChange={(e) =>
                                this.handleChange("distanceShort", e)
                              }
                              style={{ maxWidth: "150px" }}
                            />
                          </div>

                          <div className="inputBox d-flex ml-5  align-items-center">
                            <span className="fs18 darkgray-color w-100">
                              Long
                            </span>
                            <input
                              className="form-control "
                              type="text"
                              maxlength="3"
                              size="3"
                              value={this.state.distanceLong}
                              onChange={(e) =>
                                this.handleChange("distanceLong", e)
                              }
                              style={{ maxWidth: "150px" }}
                            />
                          </div>
                        </div>

                        <Select
                          labelId="role-lbl"
                          id="newRole"
                          value={this.state.unit}
                          onChange={(e) => this.handleChange("unit", e)}
                          variant="filled"
                        >
                          {this.state.distanceUnits.map((unit) => (
                            <MenuItem
                              key={unit}
                              value={unit.toLowerCase()}
                              className="FontSIze"
                            >
                              {unit}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer {...this.props} />
              <Modal
                show={this.state.showRemoveModal}
                onHide={this.closeRemoveModal}
                centered
                className="removeCountryModal"
              >
                <Modal.Body className="text-center">
                  <div className="remove-country-icon mx-auto">
                    <img src={reject} alt="reject" />
                  </div>

                  <h5 className="remove-country-title">Remove the country</h5>
                  <p className="remove-country-subtitle">
                    Are you sure you want to remove{" "}
                    <strong>{this.state.countryToRemove}</strong>?
                  </p>

                  <div className="remove-country-actions">
                    <Button
                      className="remove-country-btn remove-country-btn--cancel"
                      onClick={this.closeRemoveModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="remove-country-btn remove-country-btn--confirm"
                      onClick={this.confirmRemoveCountry}
                    >
                      Remove
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
        </div>
        <Loader showLoader={this.state.showLoader} />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  countries: state.country.countries,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCountries: () => dispatch(actionFetchCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
// export default withRouter(TotalOrderTable);
